import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User initiated a Meta account connection',
  name: 'meta_account_connection_initiated',
};

export default META;
